<template>
  <div>
    <b>General description</b>
    <br />
    This mission allows to estimate the cost of station keeping manoeuvres
    needed to counter the effects of the atmospheric drag on the semi-major axis
    of a spacecraft in low Earth orbit (up to an altitude of 1000 km).
    <br />
    <br />
    The user defines a station keeping window either by specifying the maximum
    value
    <katex-element expression="\Delta a_\mathrm{max}" /> allowed for the
    semi-major axis decay due to drag, or by specifying the size of an
    along-track box <katex-element expression="\Delta L" /> in which the
    spacecraft must remain. Every time the box is crossed, a manoeuvre is
    performed in order to bring the spacecraft
    <katex-element expression="\Delta a_\mathrm{max}" /> above the initial
    orbit. The computation of the ΔV is performed only once, using a
    semi-analytical propagator.
    <br />
    <br />
    <v-img
      contain
      :src="
        require('../../assets/images/description-station-keeping-parametric.png')
      "
      aspect-ratio="2"
    />
    <br />

    <br />
    Semi-analytical propagation is also employed once to determine the time
    needed for the semi-major axis to cross the limit of the box. This duration
    is computed only once and it is considered constant throughout the rest of
    the mission. The number of station keeping manoeuvres is given by
    <katex-element
      expression="n_\mathrm{sk} = \Delta t_\mathrm{mis} / (\Delta t_\mathrm{decay} + \Delta t_\mathrm{man})"
    />
    <br />
    <br />
    Mission results are then obtained by multiplying the results of one
    manoeuvre by <katex-element expression="n_\mathrm{sk}" />.
    <br />
    <br />
    <b>Atmospheric model</b>
    <br />
    The model considered for simulating the atmosphere of the Earth is the
    Harris-Priester model, which relies on tabulated data in order to estimate
    the value of the atmospheric density. These data correspond to a <b>mean</b>
    solar activity level.
  </div>
</template>

<script>
export default {
  name: 'tooltipParametricLEOStationKeeping'
}
</script>
